import { defineKey } from '@freshbuffer/intl';
import {
  Furnishings,
  OwnerTypeID,
  PropertyTypeID,
  PropertyAdvertSortOptionID,
} from '@klokhuis/core/ApiClient/Klokhuis';

import { ListingChipLabels, ListingStatus } from './types';

export const PropertyTypeIDTranslations: Record<PropertyTypeID, string> = {
  [PropertyTypeID.ResidentialLand]: defineKey('LBL_GENERIC_RESIDENTIAL_LAND'),
  [PropertyTypeID.HouseOrVilla]: defineKey('LBL_GENERIC_HOUSE_OR_VILLA'),
  [PropertyTypeID.FarmLand]: defineKey('LBL_GENERIC_FARM_LAND'),
  [PropertyTypeID.CommercialLand]: defineKey('LBL_GENERIC_COMMERCIAL_PROPERTY'),
};

export const PropertyTypeIDPluralTranslations: Record<PropertyTypeID, string> =
  {
    [PropertyTypeID.ResidentialLand]: defineKey('LBL_GENERIC_RESIDENTIAL_LAND'),
    [PropertyTypeID.HouseOrVilla]: defineKey('LBL_GENERIC_HOUSE_OR_VILLA'),
    [PropertyTypeID.FarmLand]: defineKey('LBL_GENERIC_FARM_LAND'),
    [PropertyTypeID.CommercialLand]: defineKey(
      'LBL_GENERIC_COMMERCIAL_PROPERTY',
    ),
  };

export const PropertyTypeIdPluralTranslationsTrimmed: Record<
  PropertyTypeID,
  string
> = {
  [PropertyTypeID.ResidentialLand]: defineKey(
    'LBL_GENERIC_RESIDENTIAL_LAND_TRIMMED',
  ),
  [PropertyTypeID.HouseOrVilla]: defineKey(
    'LBL_GENERIC_HOUSE_OR_VILLA_TRIMMED',
  ),
  [PropertyTypeID.FarmLand]: defineKey('LBL_GENERIC_FARM_LAND_TRIMMED'),
  [PropertyTypeID.CommercialLand]: defineKey(
    'LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED',
  ),
};

export const PropertyAdvertSortOptionIDTranslations: Record<
  PropertyAdvertSortOptionID,
  string
> = {
  [PropertyAdvertSortOptionID.NewestFirst]: defineKey('DMN_SORT_NEWEST_FIRST'),
  [PropertyAdvertSortOptionID.PriceAscending]: defineKey(
    'sorting.lowest_price',
  ),
  [PropertyAdvertSortOptionID.PriceDescending]: defineKey(
    'sorting.highest_price',
  ),
  [PropertyAdvertSortOptionID.Surface]: defineKey('sorting.surface'),
};

export const ListingChipLabelTranslations: Record<ListingChipLabels, string> = {
  [ListingChipLabels.New]: defineKey('label.new'),
  [ListingChipLabels.TopAd]: defineKey('LBL_RD_TOP_ADVERTISEMENT_TAG'),
  [ListingChipLabels.ReactForFree]: defineKey(
    'LBL_STEP4_CREDITS_REACT_FOR_FREE',
  ),
  [ListingChipLabels.StillAvailable]: defineKey('LBL_MOVEDUP_ADVERTISEMENT'),
  [ListingChipLabels.Sold]: defineKey('listing_status.sold'),
  [ListingChipLabels.UnderNegotiation]: defineKey(
    'listing_status.under_negotiation',
  ),
};

export const ListingStatusTranslations: Record<ListingStatus, string> = {
  [ListingStatus.Available]: defineKey('listing_status.available'),
  [ListingStatus.Sold]: defineKey('listing_status.sold'),
  [ListingStatus.UnderNegotiation]: defineKey(
    'listing_status.under_negotiation',
  ),
};

export const OwnertypeLabelTranslations: Record<OwnerTypeID, string> = {
  [OwnerTypeID.PrivateOwner]: defineKey('DMN_PRIVATE_OWNER'),
  [OwnerTypeID.RealEstateAgent]: defineKey('DMN_REAL_ESTATE_AGENT'),
  [OwnerTypeID.Other]: defineKey('LBL_OTHER'),
};

export const FurnishingLabelTranslations: Record<Furnishings, string> = {
  [Furnishings.Furnished]: defineKey('DMN_FURNISHED'),
  [Furnishings.Unfurnished]: defineKey('DMN_UNFURNISHED'),
};

export const PropertyTypeLabelTranslations: Record<PropertyTypeID, string> = {
  [PropertyTypeID.ResidentialLand]: defineKey('LBL_GENERIC_RESIDENTIAL_LAND'),
  [PropertyTypeID.HouseOrVilla]: defineKey('LBL_GENERIC_HOUSE_OR_VILLA'),
  [PropertyTypeID.FarmLand]: defineKey('LBL_GENERIC_FARM_LAND'),
  [PropertyTypeID.CommercialLand]: defineKey('LBL_GENERIC_COMMERCIAL_PROPERTY'),
};

export const UnitTypeTranslations: Record<string, string> = {
  per_sqft: defineKey('LBL_UNIT_SQFT'),
  per_cent: defineKey('LBL_UNIT_CENT'),
  per_acre: defineKey('LBL_UNIT_ACRE'),
  per_heactare: defineKey('LBL_UNIT_HECTARE'),
};

export const PropertyFormTranslations = {
  Title: defineKey('LBL_PROPERTYFORM_HEADER_TITLE'),
  Description: defineKey('LBL_PROPERTYFORM_HEADER_DESC'),
  UpdateListing: defineKey('lbl.update_listing'),
  UniqueFeatures: defineKey('lbl.unique_property_features'),
  Amenities: defineKey('lbl.amenities'),
  SearchCityPlaceholder: defineKey('search_city_placeholder'),
  EnterNearbyAreaPlaceholder: defineKey('enter_nearby_area_placeholder'),
  DraftSaved: defineKey('lbl.draft_saved_successfully'),
  CreatingUploadSession: defineKey('lbl.creating_upload_session'),
  CreatingPropertyListing: defineKey('lbl.creating_property_listing'),
  PropertyListingCreated: defineKey(
    'lbl.property_listing_created_successfully',
  ),
  FailedToCreateListing: defineKey('lbl.failed_to_create_listing'),
};
